<template>
  <div>
    <div class="review-container">
        <a-button @click="backToStudentList">学员列表</a-button>
        <div class="user-info">
            <h3>{{ userInfo.realname }} 点评</h3>
        </div>
       <div class="review-form">
            <p> 评分：({{ reviewInfo.score }})</p>
            <a-slider v-model="reviewInfo.score" :min="0" :max="5" />
            <p>评语：</p>
            <a-textarea v-model="reviewInfo.comment"> </a-textarea>
            <p>课堂记录：</p>
            <a-row>
                <a-col :span="18">
                    <j-upload capture="camera" accept="image/*" :number="1" uploadPath="user/" @saved="file=>videoUpload(item, file, 'camera')" v-model="reviewInfo.photoFile" icon="camera" text="拍照">
                        拍照
                    </j-upload>
                </a-col>
                <a-col :span="6">
                    <a-button v-if="reviewInfo.photoFile" @click="viewVideo(reviewInfo.photoFile, 'img')">查看</a-button>
                </a-col>
                <a-col :span="18">
                    <j-upload capture="camcorder" accept="video/*" :number="1" uploadPath="user/" @saved="file=>videoUpload(item, file, 'camcorder')" v-model="reviewInfo.videoFile" icon="video-camera" text="录像">
                        录像
                    </j-upload>
                </a-col>
                <a-col :span="6">
                    <a-button v-if="reviewInfo.videoFile" @click="viewVideo(reviewInfo.videoFile, 'video')">查看</a-button>
                </a-col>
            </a-row>
            <a-divider></a-divider>
            <a-button class="submit" type="primary" @click="saveReview">提交</a-button>
       </div>
    </div>
    <a-modal
      :width="800"
      :visible="videoVisible"
      :maskClosable="false"
      title="预览"
      :destroyOnClose="true"
      @cancel="videoVisible = false"
      :footer="null"
    >
      <video
        v-if="videoUrl.endsWith('.mp4')"
        style="width: 100%"
        controls
        oncontextmenu="return false;"
        controlsList="nodownload noremote footbar"
        autoplay
        :src="videoUrl"
      ></video>
      <img v-else :src="videoUrl" style="width: 100%" alt="">
    </a-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import { getAction, postAction,deleteAction } from '@/api/manage'
import JEllipsis from "@/components/jeecg/JEllipsis";
import {downloadFile} from "@/utils/qiniu.js"
import JUpload from "@/components/jeecg/JUpload";
import PreviewVideo from '@/components/tools/PreviewVideo'
export default {
    name: 'TeacherPhotoReview',
  components: {
    JEllipsis,
    JUpload,
    PreviewVideo
  },
  data() {
    return {
      videoVisible: false,
      videoUrl: '',
      userId: '',
      departId: '',
      courseId: '',
      unitId: '',
      userInfo: {},
      reviewInfo:{
        score: 0,
        comment: '',
        photoFile: '',
        videoFile: ''
      }
    }
  },
  created(){
    this.departId = this.$route.query.departId
    this.userId = this.$route.query.userId
    this.courseId = this.$route.query.courseId
    this.unitId = this.$route.query.unitId
    if(!this.userId){
        alert('参数错误')
    }
    this.getUserInfo()
    this.getReview()
  },
  methods:{
    getReview(){
        getAction("/teaching/teachingUserTimeline/getTeacherReview?userId=" + this.userId + "&unitId=" + this.unitId).then((res) => {
            if (res.success) {
                if(res.result.length > 0){
                    this.reviewInfo = JSON.parse(res.result[0].timelineContent)
                }
            }else{
                alert(res.message)
            }
        });
    },
    saveReview(){
        postAction("/teaching/teachingUserTimeline/saveTeacherReview", {
            userId: this.userId,
            unitId: this.unitId,
            score: this.reviewInfo.score,
            comment: this.reviewInfo.comment,
            photoFile: this.reviewInfo.photoFile,
            videoFile: this.reviewInfo.videoFile
        }).then((res) => {
            if (res.success) {
                this.$message.info(res.message)
            }else{
                alert(res.message)
            }
        });
    },
    videoUpload(work, file, type){
      let that = this
      console.log(work);
      console.log(file);
      let videoFile = type == 'camcorder' ? file.id:undefined
      let workCover = type == 'camera' ? file.id : undefined
    },
    viewVideo(file, type) {
        getAction("/system/sysFile/getFileUrl", {id:file}).then(url=>{
            if(url){
                if(type == 'img'){
                    this.videoUrl = url
                    this.videoVisible = true
                }else{
                    this.$layer.iframe({
                    content: {
                        content: PreviewVideo, //传递的组件对象
                        parent: this,//当前的vue对象
                        data:{
                        engine: 'videojs',
                        src: url,
                        controls: true,
                        autoplay: true
                        }//props
                    },
                    area:['480px','320px'],
                    offset: 'rightBottom',
                    shade: false,
                    shadeClose: false,
                    maxmin: true,
                    title: '视频预览',
                    cancel:()=>{//关闭事件
                    }
                    });
                }
            }
        })
    },
    getUserInfo() {
      getAction("/teaching/user/infoById?userId=" + this.userId).then((res) => {
        if (res.success) {
          this.userInfo = res.result;
        }else{
            alert(res.message)
        }
      });
    },
    backToStudentList(){
        this.$router.push({
            path: '/classStudent',
            query:{
                departId: this.departId,
                courseId: this.courseId,
                unitId: this.unitId
            }
        })
    }
  },
}
</script>

<style scoped>
.review-container{
    margin: auto;
    padding: 12px;
    max-width: 800px;
}
.review-form .submit{
    display: block;
    width: 200px;
    margin: auto;
}
</style>